:host {
  display: block;
  margin-bottom: var-rem(--semantic-spacing-lg);

  .navigation-list--title {
    padding-bottom: var-rem(--semantic-spacing-3xs);
    font-family: var(--semantic-typography-font-family-primary), var(--font-fallbacks);
    font-weight: 700;
    color: var(--semantic-color-text-subtlest);
  }

  ul {
    display: flex;
    flex-direction: column;
    gap: var-rem(--semantic-spacing-3xs);
    margin: 0;
    padding: 0;
    list-style-type: none;
  }
}

:host([has-bold-links]),
:host([has-bold-links='true']) {
  --wink-navigation-list-underline-thickness: var(--semantic-border-lg);
  --wink-navigation-list-font-family: var(--semantic-typography-font-family-primary), var(--font-fallbacks);
  --wink-navigation-list-font-weight: 700;
}
